import { useToggleRefinement } from 'react-instantsearch';
import type { FilterProps } from '@javascript/types/InstantSearch';

export interface ToggleFilterProps extends FilterProps {
  id: string;
  toggledValue?: boolean;
}

const InstantSearchToggle = ({
  attribute,
  id,
  label,
  toggledValue = true,
}: ToggleFilterProps) => {
  const { value, refine } = useToggleRefinement({
    attribute,
    on: toggledValue,
  });

  return (
    <div className="ac-instant-search__filter-toggle ch-display--flex ch-align-items--center ch-bg--white ch-pv--3 ch-ph--3 sl:ch-ph--6 ch-bb--1 ch-bc--grey-3">
      <input
        checked={value.isRefined}
        className="ch-checkbox"
        id={id}
        onChange={(e) => refine({ isRefined: !e.target.checked })}
        type="checkbox"
      />
      <label
        className="ch-checkbox__label ch-checkbox__label--hide-checkbox ch-fs--4 ch-fw--500 ch-display--flex ch-justify-content--between ch-width--12"
        htmlFor={id}
      >
        {label}
        <span className="ch-toggle"></span>
      </label>
    </div>
  );
};

export default InstantSearchToggle;
